export default {
	methods: {
		sortArray (array, criteria, order) {
			if (order === 'asc') {
				return array.sort((a, b) => a[criteria].localeCompare(b[criteria]))
			} else {
				return array.sort((a, b) => b[criteria].localeCompare(a[criteria]))
			}
		}
	}
}
